import * as actionTypes from '../actionTypes/footer';

export function getPowerUpdate(value) {
    return { type: actionTypes.ENTER_POWER_LOAD, value};
}
